import type { SxProps, Theme } from "@mui/material";
import TaskSelector from "src/business-components/input/TaskSelector/TaskSelector";
import { useComparativeAnalysisFormTask } from "./ComparativeAnalysisFormTask.hooks";
import { parseTask } from "./ComparativeAnalysisFormTask.utils";

interface ComparativeAnalysisFormTaskProps {
  disabled?: boolean;
  env?: string;
  formSx?: SxProps<Theme>;
  isLoading?: boolean;
  onChange?: (task: string | undefined) => void;
  pipelineId?: string;
  pipelineName?: string;
  pit?: string;
  setIsValidValue: (isValid: boolean | undefined) => void;
  task?: string;
}

const ComparativeAnalysisFormTask = ({
  task,
  disabled,
  formSx,
  onChange,
  pipelineId,
  pit,
  ...props
}: ComparativeAnalysisFormTaskProps) => {
  const [taskName = ""] = parseTask(task);

  const taskSelectorProps = useComparativeAnalysisFormTask({
    taskName,
    disabled,
    onChange,
    pit,
    ...props,
  });

  return (
    <TaskSelector
      {...{ formSx, disabled }}
      {...taskSelectorProps}
      slotProps={{
        renderOption: {
          disabledUnclickable: true,
          app_pit: pit,
        },
        renderInput: {
          TextField: {
            label: taskSelectorProps.isLoading
              ? "Fetching tasks…"
              : task
                ? "Task"
                : "Tasks within the selected run",
          },
        },
      }}
      noOptionsText="To select a task, first select a pipeline run"
    />
  );
};

export default ComparativeAnalysisFormTask;
